import { useState, type FormEvent } from 'react'
import { loginTotp } from '../api'

interface Props {
  continuationToken: string
  onLoggedIn: () => void
  onCancel: () => void
}

export function TotpChallenge({ continuationToken, onLoggedIn, onCancel }: Props) {
  const [code, setCode] = useState('')
  const [useRecovery, setUseRecovery] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    const result = await loginTotp(continuationToken, code.trim())
    setLoading(false)
    if ('error' in result) {
      setError('Code rejected')
      return
    }
    onLoggedIn()
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <div className="text-2xl font-light mb-1">Two-factor</div>
          <div className="text-sub text-sm">
            {useRecovery ? 'Enter a recovery code' : 'Enter the 6-digit code from your authenticator'}
          </div>
        </div>

        <input
          autoFocus
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder={useRecovery ? 'recovery code' : '000000'}
          inputMode={useRecovery ? 'text' : 'numeric'}
          maxLength={useRecovery ? 32 : 6}
          className="w-full bg-panel border border-border rounded-md px-4 py-3 text-ink text-center text-2xl tracking-widest focus:outline-none focus:border-accent"
        />

        {error && <div className="text-err text-sm text-center">{error}</div>}

        <button
          type="submit"
          disabled={loading || !code}
          className="w-full bg-accent text-white font-medium py-3 rounded-md disabled:opacity-50"
        >
          {loading ? 'Verifying…' : 'Verify'}
        </button>

        <div className="text-center text-sm">
          <button
            type="button"
            onClick={() => { setUseRecovery(!useRecovery); setCode(''); setError(null) }}
            className="text-sub hover:text-ink underline"
          >
            {useRecovery ? 'Use authenticator app instead' : 'Use a recovery code instead'}
          </button>
        </div>
        <div className="text-center text-sm">
          <button type="button" onClick={onCancel} className="text-sub hover:text-ink underline">Cancel</button>
        </div>
      </form>
    </div>
  )
}
